import { render, staticRenderFns } from "./MetaDataInfo.vue?vue&type=template&id=00ef890c&"
import script from "./MetaDataInfo.vue?vue&type=script&lang=js&"
export * from "./MetaDataInfo.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports